import React from 'react';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import DivContainerBody from "../../components/DivContainerBody";
import DividerWithText from "../../components/DividerWithText";
import HeadTittle from "../../components/HeadTittle";
import NotInformation from "../../components/NotInformation";
import ButtonAction from "../../components/buttons/ButtonAction";
import CustomCard from "../../components/CustomCard";
import RowCardText from "../../components/RowCardText";
import WhiteListErrorCard from "./SubComponents/Residents/WhiteListErrorCard";
import CreationErrorsWhiteListApp from "./Functionality/CreationErrorsWhiteListApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Import errors of the white list, opened when the create all endpoint saves
 * only part of the residents. It paints the totals of the import, the failed
 * rows on an editable grid and one card per error, the same way the excel
 * imports of the other modules do. Verify sends the corrected rows again.
 */
const CreationErrorsWhiteList = () => {
    const {
        t,
        jRef,
        failures,
        totalRecords,
        savedRecords,
        failedRecords,
        getReasonMessage,
        handleVerify,
        goBack
    } = CreationErrorsWhiteListApp();

    return (
        <>
            <HeadTittle name={t('import')} onBack={goBack}>
                <ButtonAction
                    id='btn_cewl_verify'
                    name='verify'
                    className='btn-icon-accent-450'
                    onClick={handleVerify}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-5'>
                    <div className={"col-12 mb-4 px-0"}>
                        <DividerWithText title={t('white_list')} />
                    </div>
                    <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4'>
                        <CustomCard>
                            <RowCardText title={t('total_records')} value={totalRecords} />
                            <RowCardText title={t('saved_records')} value={savedRecords} />
                            <RowCardText title={t('failed_records')} value={failedRecords} />
                        </CustomCard>
                    </div>
                    <div className={"col-12 px-0"} ref={jRef} />
                </div>

                <div className={"row mt-5"}>
                    <div className={"col-12 mb-4 px-0"}>
                        <DividerWithText title={t('ERRORS') + "(" + failedRecords + ")"} />
                    </div>

                    {failures?.length > 0 ?
                        failures.map((failure, index) => (
                            <WhiteListErrorCard
                                key={`${failure?.rowNumber}-${index}`}
                                number={index + 1}
                                failure={failure}
                                description={getReasonMessage(failure?.reason)}
                            />
                        ))
                        :
                        <div className={"col-12 mb-4 px-0"}>
                            <NotInformation text={t('no_errors_found')} card={false} />
                        </div>
                    }
                </div>
            </DivContainerBody>
        </>
    );
};

export default CreationErrorsWhiteList;
